/* eslint-disable no-console */
// import { register } from 'register-service-worker';
import { ls } from '@sfe/bone-cache';

const main = async () => {
    if (window.caches) {
        const keys = await caches.keys();
        const deleteKeys = keys.filter((cacheName) => cacheName.indexOf('trade-spot-') === 0);
        await Promise.all(deleteKeys.map((key) => caches.delete(key)));
    }

    // 卸载 Service Worker
    if (window.navigator && navigator.serviceWorker) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        // eslint-disable-next-line
        for (const item of registrations) {
            if (item.active && String(item.active.scriptURL).indexOf('/trade/spot/pro/static/trade-spot-sw.js') > 0) {
                // eslint-disable-next-line
                await item.unregister();
            }
        }
    }
};

// 去掉原本注册的 Service Worker 的入口。保留目前暂需清除缓存的逻辑。
if (process.env.NODE_ENV === 'production' && window.location.protocol === 'https:' && ls.get('SPOT_nosw') !== '1') {
    if (process.env.SFE_SERVICE_WORKER === 'true') {
        // register('/trade/spot/pro/static/trade-spot-sw.js', {
        //     registrationOptions: { scope: '/' },
        //     // ready() {
        //     //     console.log('App is being served from cache by a service worker.');
        //     // },
        //     // registered() {
        //     //     console.log('Service worker has been registered.');
        //     // },
        //     // cached() {
        //     //     console.log('Content has been cached for offline use.');
        //     // },
        //     // updatefound() {
        //     //     console.log('New content is downloading.');
        //     // },
        //     // updated() {
        //     //     console.log('New content is available; please refresh.');
        //     // },
        //     // offline() {
        //     //     console.log('No internet connection found. App is running in offline mode.');
        //     // },
        //     // error(error) {
        //     //     console.error('Error during service worker registration:', error);
        //     // },
        // });
    } else {
        try {
            main();
        } catch (e) {} // eslint-disable-line
    }
}
